import { gql } from "@apollo/client";

const GET_CLIENT_TEMPLATES = gql`
  query clientTemplates($clientIdentifier: String!) {
    client(clientIdentifier: $clientIdentifier) {
      id
      invoiceReaderTemplates {
        id
        name
        state
        eInvoiceTested
        mappedRowFieldCount
        modifiedAt
        notes
        templateType
        templateLanguage
      }
    }
  }
`;

export default GET_CLIENT_TEMPLATES;
